module.exports = __webpack_public_path__ + "static/media/info.f29c9920.svg";